import { observer } from "mobx-react-lite";

import cartStore from "../../stores/cart/cartStore";

import MiniCartOrderLines from "./MiniCartOrderLines";

const EmptyCart = observer(() => (
   <div className="grow flex flex-col justify-center items-center">
      <h4>Du har ingen varer i handlekurven</h4>
   </div>
));

const MiniCartContent = () => {
   const items = cartStore.items;
   const empty = items.length === 0;

   return !empty ? <MiniCartOrderLines items={items} /> : <EmptyCart />;
};

export default observer(MiniCartContent);
